import React, {useEffect, useState} from 'react';
import {PanelWrapper} from "../../../components";
import UserCard from "../../../components/user-card/user-card";
import {useParams} from "react-router-dom";
import {fetchData} from "../../../helpers/general-function";
import Notification from "../../../helpers/notifications";
import moment from "moment-jalaali";
import {ShiftRemain} from "./my-request-single.styles";
import {Modal} from "react-responsive-modal";
import {ShiftModalContainer} from "../../Requests/requests.styles";

const MyRequestSingle = () => {

    const {shift_time_id} = useParams();

    const [shiftData, setShiftData] = useState({});
    const [acceptShiftData, setAcceptShiftData] = useState(null);

    useEffect(() => {
        (async () => {
            const data = await fetchData(`panel/shift-times/info/${shift_time_id}`, 'get', {}, true);

            if (data) {
                setShiftData(data);
            }
        })()
    }, []);

    const acceptPharmacy = async () => {
        const shiftRequestId = acceptShiftData.id;

        const data = await fetchData(`panel/shift-times/${shift_time_id}/set-pharmacist/${shiftRequestId}`, 'post', {}, true);

        if (data) {
            const currentRequestShifts = [...shiftData.shift_requests];
            let targetRequestShift = currentRequestShifts.find(item => item.id === shiftRequestId);
            targetRequestShift = {...targetRequestShift, employed: '1'};

            const finalRequestShifts = currentRequestShifts.map(item => {
                if (item.id === shiftRequestId) {
                    return targetRequestShift;
                } else {
                    return item;
                }
            });

            setShiftData(prevState => ({
                ...prevState,
                has_accepted_request: true,
                shift_requests: finalRequestShifts
            }));
            Notification.success('داروساز مورد نظر با موفقیت پذیرفته شد');
        }

        setAcceptShiftData(null);
    }

    return (
        <>
            <PanelWrapper activeRouteData={{icon: 'icon-people', name: 'درخواست‌های من'}}>
                <div className='d-lg-flex align-items-center justify-content-between mt-4 mt-lg-0'>
                    <h3 className='success-color'>درخواست شیفت برای {shiftData.shift_time?.shift.pharmacy.name}</h3>
                    <div className='d-flex align-items-center justify-content-between mt-3 mt-lg-0'>
                        {
                            shiftData.shift_time && !moment().isAfter(moment(shiftData.shift_time.from)) ?
                                <ShiftRemain
                                    className='mb-0 mt-lg-0 danger-color'>{`${moment(shiftData.shift_time.from).diff(moment().format('YYYY-MM-DD HH:mm:ss'), 'day')} روز و ${moment(shiftData.shift_time.from, 'YYYY-MM-DD HH:mm:ss').subtract(moment().format('HH:mm:ss')).format('HH:mm')} `} مانده
                                    تا آغاز شیفت</ShiftRemain>
                                :
                                <ShiftRemain className='mb-0 mt-lg-0 danger-color'>شیفت منثضی شده</ShiftRemain>
                        }
                        <p className='m-0 d-lg-none'>
                            <span className='dark-gray'>{shiftData.shift_requests?.length}</span>
                            <i className='icon-users align-middle ms-2'/>
                        </p>
                    </div>
                </div>
                <p className='mt-3 d-none d-lg-block'>تاکنون {shiftData.shift_requests?.length} نفر برای شیفت شما اعلام
                    آمادگی کرده است.</p>
                <div className='row mt-5'>
                    {
                        shiftData.shift_requests?.map(item => (
                            <div className='col-12 col-md-6 ' key={item.id}>
                                <UserCard
                                    name={item.requesting_user.name}
                                    type={item.requesting_user.type === 'student' ? 'دانشجو' : 'داروساز'}
                                    status={item.employed.toString() === '1' ? 'active' : !shiftData.has_accepted_request ? null : 'reject'}
                                    descChildren={
                                        <div className='d-flex flex-wrap align-items-center mt-3 rtl'>
                                            <p className='fs-c-6 light-gray ms-4'>{item.requesting_user.mean_rate}%<i
                                                className='icon-heart-2 ms-2'/> میزان رضایت</p>
                                            <p className='fs-c-6 light-gray'>{item.requesting_user.mobile}<i
                                                className='icon-call ms-2'/></p>
                                        </div>
                                    }
                                    image_source='http://www.best4geeks.com/wp-content/uploads/2018/12/4.-awesome-profile-pic-1.jpg'>

                                    <div className='d-flex justify-content-center mt-4'>
                                        {
                                            item.employed.toString() === '1' ?
                                                <p className='c-btn simple-btn-success d-inline-block flex-grow-1 flex-lg-grow-0 mb-0 text-center py-c-2'>داروساز
                                                    پذیرفته شد.</p>
                                                :
                                                <button
                                                    className='c-btn simple-btn-success flex-grow-1 flex-lg-grow-0 py-c-2'
                                                    onClick={!shiftData.has_accepted_request ? () =>
                                                        setAcceptShiftData({id: item.id, name: item.requesting_user.name}) : () => {}}>پذیرش داروساز
                                                </button>
                                        }

                                    </div>

                                </UserCard>
                            </div>
                        ))
                    }
                </div>
            </PanelWrapper>

            <Modal open={!!acceptShiftData} onClose={() => setAcceptShiftData(null)}
                   classNames={{modal: 'c-modal-container'}}
                   showCloseIcon={false} center>
                <ShiftModalContainer>
                    <div className='text-center mt-3 mt-c-lg-2_5'>
                       <h3 className='success-color'>پذیرفتن {acceptShiftData?.name} برای شیفت {shiftData.shift_time?.shift.pharmacy.name}</h3>
                        <p className='mb-0 gray-color mt-4 rtl lh-normal'>
                            اگر از پذیرش این فرد مطمئن هستید، تایید را انتخاب کنید. <br className='d-lg-none' />
                            هماهنگی های بیشتر بعهده درخواست دهنده می‌باشد.<br className='d-lg-none' />
                            شماره تلفن داروساز در صفحه پیش موجود است.
                        </p>

                        <div className='d-flex align-items-center justify-content-center mt-5 rtl'>
                            <button className='c-btn simple-btn-success px-lg-5 py-c-2' onClick={acceptPharmacy}>پذیرش داروساز</button>
                            <button className='btn-text me-4' onClick={() => setAcceptShiftData(null)}>بازگشت به صفحه قبلی</button>
                        </div>
                    </div>
                </ShiftModalContainer>
            </Modal>

        </>
    );
};

export default MyRequestSingle;
